<template>
  <component :is="component" :data="data" />
</template>
<script lang="ts" setup>
import { computed, PropType } from 'vue';
import { CompositeComponent } from '@bifrost-dev-docs-mfe/common/types/compositeComponents';
import ProductHeader from '@/components/composite/components/ProductHeader.vue';
import RelatedProducts from '@/components/composite/components/RelatedProducts.vue';
import SignUpCTA from '@/components/composite/components/SignUpCTA.vue';
import CodeExamples from '@/components/composite/components/CodeExamples.vue';
import NavCards from '@/components/composite/components/NavCards/index.vue';

const props = defineProps({
  data: { type: Object as PropType<CompositeComponent>, required: true },
});

const components = {
  ProductHeader,
  RelatedProducts,
  SignUpCTA,
  CodeExamples,
  NavCards,
};

const component = computed(() => components[props.data.component]);
</script>
